import { ChangeEvent, FormEvent, useEffect, useState } from "react";
import styles from "../../General CSS/Form.module.css";
import { getHousemates } from "../../API/HousemateManager";
import { Housemate } from "../../Types/Housemate";
import { addQuote, QuoteTemplate } from "../../API/QuotesManager";
import { useNavigate } from "react-router-dom";
import Header from "../../Header";

export default function Add() {
    const [formData, setFormData] = useState<QuoteTemplate>({
        saidBy: "",
        quote: "",
    });

    const navigate = useNavigate();

    const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (formData.saidBy === "") {
            alert("Please select someone!");
            return;
        }

        try {
            await addQuote(formData);
            navigate("/quotes");
        } catch (err: any) {
            alert(err.message || "Failed to add quote");
        }
    }
    return (
        <>
            <Header page={"Add a Quote"} returnLink={"/quotes"}/>
            <div className={styles.wrapper}>
                <form onSubmit={handleSubmit}>
                    <div className={styles.dropdown}>
                        <select id="saidBy" name="saidBy" onChange={handleChange} value={formData.saidBy}>
                            <GetHousematesOptions />
                        </select>
                    </div>
                    <div className={styles.dropdown}>
                        <label htmlFor="quote" className={styles.label}>Quote:</label>
                        <input id="quote" type="text" name="quote" onChange={handleChange} className={styles.inputText} />
                    </div>
                    <div className="submit">
                        <input className={styles.submitBtn} type="submit" value="Submit" title="Submit" />
                    </div>
                </form>
            </div>
        </>
    )
}

function GetHousematesOptions() {
    const [housemates, setHousemates] = useState<Housemate[]>([]);

    useEffect(() => {
        const fetchHousemates: () => Promise<void> = async (): Promise<void> => {
            try {
                const data: Housemate[] = await getHousemates();
                setHousemates(data);
            } catch (error) {
                console.error("Failed to fetch housemates: ", error);
            }
        };

        fetchHousemates();
    }, []);

    return (
        <>
            <option value="">-- Select a housemate --</option> {/* default */}
        { housemates.map((housemate: Housemate) => (
            <option key={housemate.email} value={housemate.email}>
                {housemate.name}
            </option>
        ))}
        </>
    );
}